import { useState } from "react"
import { Button, Card, Input, Typography, App } from "antd"
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons"
import SuperAdminContainer from "../SuperAdminContainer"
import { ScreenHeader } from "../../../CommonComponents"
import { chantApi } from "../../../utils/chantApi"

const { Text } = Typography
const BASE = import.meta.env.VITE_GCP_BASE_URL

const UserRoles = () => {
  const { message, modal } = App.useApp()
  const [userId, setUserId] = useState("")
  const [loading, setLoading] = useState(null)

  const call = async (action) => {
    const trimmed = userId.trim()
    if (!trimmed) {
      message.error("Enter a userId first")
      return
    }

    const label = action === "promote" ? "promote to superadmin" : "demote from superadmin"

    modal.confirm({
      title: `Confirm: ${label}`,
      content: (
        <span>
          User ID: <Text code>{trimmed}</Text>
          <br />
          This will update their Firebase custom claims and Firestore role.
        </span>
      ),
      okText: "Yes, proceed",
      okButtonProps: { danger: action === "demote" },
      onOk: async () => {
        setLoading(action)
        try {
          const res = await chantApi.post(`${BASE}/superadmin/users/${action}`, { userId: trimmed })
          message.success(res.data.message)
          setUserId("")
        } catch (err) {
          message.error(err?.response?.data?.message || `Failed to ${action} user`)
        } finally {
          setLoading(null)
        }
      },
    })
  }

  return (
    <SuperAdminContainer>
      <ScreenHeader title="User Roles" />
      <Card style={{ maxWidth: 480, marginTop: 24 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <Text strong>Firebase User ID</Text>
            <Input
              placeholder="e.g. abc123XYZ..."
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              style={{ marginTop: 6 }}
              allowClear
            />
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <Button
              type="primary"
              icon={<ArrowUpOutlined />}
              loading={loading === "promote"}
              disabled={loading === "demote"}
              onClick={() => call("promote")}
            >
              Promote to Superadmin
            </Button>
            <Button
              danger
              icon={<ArrowDownOutlined />}
              loading={loading === "demote"}
              disabled={loading === "promote"}
              onClick={() => call("demote")}
            >
              Demote from Superadmin
            </Button>
          </div>
        </div>
      </Card>
    </SuperAdminContainer>
  )
}

export default UserRoles
